__turbopack_context__.v({
  "fe1": "wroTyG_fe1",
  "fe2": "wroTyG_fe2",
  "fe3": "wroTyG_fe3",
  "fe4": "wroTyG_fe4",
  "fe5": "wroTyG_fe5",
  "fe6": "wroTyG_fe6",
  "fe7": "wroTyG_fe7",
  "loading_spinner": "wroTyG_loading_spinner",
  "loading_spinner__dep_reduced_motion": "wroTyG_loading_spinner__dep_reduced_motion",
  "loading_spinner__text": "wroTyG_loading_spinner__text",
  "loading_spinner_svg": "wroTyG_loading_spinner_svg",
  "spin": "wroTyG_spin",
});
